





























































































































































































































































































































































































































































































































































































































































import { Component } from "vue-property-decorator";
import axios from "axios";
import HacoBase from "../HacoBase";

@Component
export default class PrinterEditComp extends HacoBase {
  editData: any = {};
  $debugServer!: string;
  costTypeA = true;
  costTypeB = false;
  costTypeC = false;
  defData: any = {};

  mounted(): void {
    let editId: number;
    if (this.$route.params.id === undefined) {
      return;
    } else {
      editId = parseInt(this.$route.params.id, 10);
      this.defData = {
        id: editId,
        itemPrinterName: "",
        costType: "digital",
        fixedCostHour: 0,
        preparationTimeMin: 0,
        chargeUnitCost: null,
        offsetMinFixCost: null,
        offsetPlateCost: null,
        printBufferCosts: [
          {
            sheetFrom: 0,
            sheetTo: -1,
            buffer: 0
          }
        ],
        printPerSheetColorCost: [
          {
            sheetFrom: 0,
            sheetTo: -1,
            cost: 0
          }
        ],
        printSpeedCosts: [],
        printInkCosts: {
          costForMaxSize: 0,
          maxSizeW: 0,
          maxSizeD: 0
        },
        printProofingCosts: {
          proof3dweb: 0,
          proofReal: 0
        }
      };

      let url = this.$debugServer + "/api/v1_inner/printer/";
      const accessMethod = "get";
      /** 新規の場合 */
      if (editId === -1) {
        url = this.$debugServer + "/api/v1_inner/printer/-1/edit";
        this.costTypeA = true;
        this.costTypeB = false;
        this.costTypeC = false;
      } else {
        url += this.$route.params.id + "/edit";
      }
      const params: object = this.setAxiosParams(url, accessMethod);

      axios(params)
        .then((response: any): void => {
          this.editData = response.data;
          let i = 0;
          for (const item of this.editData.printDimantionType) {
            this.defData.printSpeedCosts[i] = {
              itemPrinterId: -1,
              printDimensionTypeId: item.id,
              printSpeed: 0
            };
            i += 1 | 0;
          }
          if (editId === -1) {
            this.editData.printer = this.defData;
            this.changeCostType("digital");
          }
          const costType: string = this.editData.printer.costType;

          if (costType === "digital") {
            this.costTypeA = true;
            this.costTypeB = false;
            this.costTypeC = false;
          } else if (costType === "charge") {
            this.costTypeA = false;
            this.costTypeB = true;
            this.costTypeC = false;
          } else {
            this.costTypeA = false;
            this.costTypeB = false;
            this.costTypeC = true;
          }
        })
        .catch((error: any): void => {
          console.log("[mount error]", error);
          this.toLoginPage(error);
        });
    }
  }

  checkInputKeys(e: KeyboardEvent): void {
    if (e.ctrlKey === true && e.key === "Enter") {
      this.onSubmit();
    }
  }

  onSubmit(back = false): void {
    const mes = this.$t("message.editCommon.saveConfirmation");
    const confirmation: boolean = confirm(mes as string);
    if (confirmation === false) {
      return;
    }
    const editData: any = this.editData;
    const printerData: any = editData.printer;
    let sheetError = false;
    const bool: boolean = this.resetSheetFromEle();
    if (bool === true) {
      return;
    }

    let sheetValueCheck: number[] = this.checkSheetValue(
      printerData.printBufferCosts
    );

    /** sheetFromおかしかったらエラー出す */
    if (sheetValueCheck[1] !== -1) {
      this.showSheetFromError(sheetValueCheck);
      sheetError = true;
    }

    if (printerData.costType === "offset") {
      sheetValueCheck = this.checkSheetValue(
        printerData.printPerSheetColorCost
      );

      /** sheetFromおかしかったらエラー出す */
      if (sheetValueCheck[1] !== -1) {
        this.showSheetFromError(sheetValueCheck, "colorCost");
        sheetError = true;
      }
      if (sheetError === true) {
        return;
      }

      /** 問題なかったらsheetToの値を設定 */
      this.setSheetTo(printerData.printPerSheetColorCost);

      /** 不要データをnullにする */
      printerData.fixedCostHour = null;
      printerData.preparationTimeMin = null;
      printerData.chargeUnitCost = null;
      printerData.printSpeedCosts = [];
      printerData.printInkCosts = null;
    } else if (printerData.costType === "charge") {
      if (sheetError === true) {
        return;
      }
      printerData.offsetMinFixCost = null;
      printerData.offsetPlateCost = null;
      printerData.printPerSheetColorCost = [];
      printerData.printInkCosts = null;
    } else {
      if (sheetError === true) {
        return;
      }
      printerData.chargeUnitCost = null;
      printerData.offsetMinFixCost = null;
      printerData.offsetPlateCost = null;
      printerData.printPerSheetColorCost = [];
    }

    /** itemPrinterId統一(新規継続対策) */
    for (const item of printerData.printBufferCosts) {
      item.itemPrinterId = printerData.id;
    }
    /** 問題なかったらsheetToの値を設定 */
    this.setSheetTo(printerData.printBufferCosts);
    /** 表記の揺れ対策 */
    interface CategoryObj {
      category: string;
      backTo: string;
      dataName: string;
    }
    const categoryObj: CategoryObj = {
      category: "printer",
      backTo: "Printer",
      dataName: "printer"
    };
    const id: number = parseInt(printerData.id, 10);
    this.sendEditData(id, editData, categoryObj, back, this.afterSaving);
  }

  afterSaving(): void {
    void 0;
  }

  /** コストタイプ変更 */
  changeCostType(costType: string): void {
    const data: any = this.editData.printer;
    data.costType = costType;
    this.editData.printer.costType = costType;

    /** 初期値を設定する  */
    if (costType === "offset") {
      if (
        data.printPerSheetColorCost === null ||
        data.printPerSheetColorCost.length === 0
      ) {
        data.printPerSheetColorCost = Object.assign(
          [],
          this.defData.printPerSheetColorCost
        );
      }
    } else if (costType === "digital") {
      if (data.printSpeedCosts === null || data.printSpeedCosts.length === 0) {
        data.printSpeedCosts = Object.assign([], this.defData.printSpeedCosts);
      }
      if (data.printInkCosts === null) {
        data.printInkCosts = Object.assign({}, this.defData.printInkCosts);
      }
    }
  }
}
